<template>
    <button-group>
        <template v-slot:meta>
            <v-col cols="12">
                <v-text-field v-model="mValue.GroupTitle" label="Button Group Title"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3" lg="2" class="d-flex">
                <NumberColumnsTextField v-model="mValue.NumColumns" label="Number of Columns" :tooltip="numColumnsTooltip" />
            </v-col>
        </template>

        <template v-slot:Buttons>
			<DraggableGroupItems
				v-model="mValue.Buttons"
				items-label="Button"
				:items-style="itemsStyle"
				class="full-width"
				@add-item="addItem"
				@delete-item="deleteItem"
			>
				<template v-slot:default="{ item }">
					<v-text-field label="Button Text" v-model="item.text"></v-text-field>
					<url-selector v-model="item.href" label="Button Link"></url-selector>
					<v-checkbox class="mt-0" v-model="item.newWindow" label="open in new window" false-value="_self" true-value="_blank"></v-checkbox>
					<v-combobox label="Color" v-model="item.color" :items="available_colors"></v-combobox>
				</template>
			</DraggableGroupItems>
        </template>
    </button-group>
</template>

<script>
import TextEditor from '../TextEditor.vue'
import ButtonGroup from '@/CMS/views/ContentBlocks/ButtonGroup.vue'
import UrlSelector from '../UrlSelector.vue'
import NumberColumnsTextField from '@/CMS/editor/components/NumberColumnsTextField.vue'
import DraggableGroupItems from '@/CMS/editor/components/DraggableGroupItems.vue'
import { CmsGroupEditorMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
	components: {
        TextEditor,
        ButtonGroup,
        UrlSelector,
		NumberColumnsTextField,
		DraggableGroupItems,
    },
	mixins: [CmsGroupEditorMixin],
    props: {
		value: { type: Object },
	},
    data () {
        return {
			itemsName: 'Buttons', // override Mixin
        }
    },
    methods: {
        reset () { // override Mixin
			const value = { ...this.mValue }
            if (typeof value.Buttons === 'undefined') {
				value.Buttons = [this.getNewItem()]
            }
			if (typeof value.NumColumns === 'undefined') {
				value.NumColumns = 4
			}
            if (typeof value.GroupTitle === 'undefined') {
				value.GroupTitle = ''
            }
			value.Buttons.map((button) => {
				const btn = { ...button }
				if (typeof btn.id === 'undefined') {
					this.counter = this.counter + 1
					btn.id = this.counter
				}
				return btn
			})
            this.mValue = value
        },
		getNewItem () { // override Mixin
			this.counter = this.counter + 1
			return {
                id: this.counter,
                text: 'Click',
                href: 'https://www.quility.com',
                newWindow: '_blank'
            }
		},
    },
}
</script>
